module.exports = __webpack_public_path__ + "img/hr-puberty-decal-10.9c3f92a1.png";